@let brandListLoading = brandsListLoading$ | async;
@let brandsList = brandsList$ | async;

@if (isDisplayed) {
  <div>
    <div class="select-container">
      <div class="machine-type-container">
        <div>
          <input
            id="machine-type-all"
            type="radio"
            [value]="null"
            name="machine-type"
            [(ngModel)]="selectedMachineType"
            (change)="this.handleInputChanged()" />
          <label for="machine-type-all">
            {{ 'compatibility.compatibleMachines.filters.all' | translate }}
          </label>
        </div>
        @if (sportMachine.length > 1) {
          @for (mType of sportMachine; track $index) {
            <div>
              <input
                id="machine-type-{{ mType }}"
                type="radio"
                name="machine-type"
                [value]="mType"
                [(ngModel)]="selectedMachineType"
                (change)="this.handleInputChanged()" />
              <label for="machine-type-{{ mType }}">
                {{
                  'browse.filterSort.filters.equipment.options.' +
                    machineTypeLabels[mType] | translate
                }}
              </label>
            </div>
          }
        }
      </div>
      <label for="brand-select" translate
        >watch.ranking_modal.equipment.brand</label
      >
      @if (!brandListLoading) {
        <select
          [disabled]="brandListLoading"
          class="select-box"
          name="brand-select"
          [(ngModel)]="selectedManufacturer"
          (change)="handleInputChanged()">
          <option [value]="null">
            {{ 'watch.ranking_modal.equipment.brand_selection' | translate }}
          </option>
          @for (brand of brandsList; track $index) {
            <option [ngValue]="brand">
              {{ brand.name }}
            </option>
          }
        </select>

        <!-- ? A voir si on veut pouvoir trier précisément par modèle (actuellement
        impossible dans l'appel API)
        @if (selectedManufacturer) {
          <label for="brand-select" translate
            >compatibility.compatibleMachines.models</label
          >
          <select
            [disabled]="brandListLoading"
            class="select-box"
            name="brand-select"
            [(ngModel)]="selectedEquipment"
            (change)="handleInputChanged()">
            <option [value]="null">
              {{ 'compatibility.compatibleMachines.filters.all' | translate }}
            </option>

            @if (selectedManufacturer.classic?.length > 0) {
              <option [value]="null" disabled>-- classic --</option>
              @for (equipment of selectedManufacturer?.classic; track $index) {
                <option [ngValue]="equipment">
                  {{ equipment.name }}
                </option>
              }
            }
            @if (selectedManufacturer.interactive?.length > 0) {
              <option [value]="null" disabled>-- interactive --</option>
              @for (
                equipment of selectedManufacturer?.interactive;
                track $index
              ) {
                <option [ngValue]="equipment">
                  {{ equipment.name }}
                </option>
              }
            }
            @if (selectedManufacturer.smart?.length > 0) {
              <option [value]="null" disabled>-- smart --</option>
              @for (equipment of selectedManufacturer?.smart; track $index) {
                <option [ngValue]="equipment">
                  {{ equipment.name }}
                </option>
              }
            }
          </select>
        } -->
      } @else {
        <p-skeleton height="60px" borderRadius="0.75em" />
      }
    </div>
  </div>
}
